import { Injectable, Inject } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { DOCUMENT } from "@angular/common";
import { IAppState } from "../../../store/states/app";
import { Store } from "@ngrx/store";

declare const swal: any;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _store: Store<IAppState>,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        return event;
      }),
    );
  }
}
